// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"353ed598","966":"e9829a18"}[chunkId] + ".chunk.css";
};